import { type Variants } from '@mc/experiments'
import * as nr from '../adapters/newrelic'
import { log } from '../utils/log'

export const experiment = (
  name: string,
  bucket: Variants | null | undefined,
) => {
  if (!bucket) return

  log('experiment', { [name]: bucket })
  nr.trackEvent(`experiment-${name}`, bucket)
}
